import React from 'react';

const openIcon = () => (
    <svg viewBox="0 0 60 30">
        <polygon points="60,0 0,0 30,30 " />
    </svg>
)

export default openIcon;